<div class="header">
  <div class="header-copy">
    <div [ngClass]="getTagCSS(selectedItem.status)">{{ getTagLabel(selectedItem.status) }}</div>
  </div>
  <div class="header-actions">
    @if (selectedItem.fileLink || selectedItem.fileUrl) {
      <button mat-stroked-button color="primary" (click)="openFilePreview()"><mat-icon>visibility</mat-icon>Preview File</button>
    }
    <button mat-stroked-button color="primary" (click)="sourceFileInput.click()"><mat-icon>upload</mat-icon>Upload File</button>
    <button mat-stroked-button color="warn" class="danger-action" (click)="openDeleteSourceModal()"><mat-icon>delete</mat-icon>Delete</button>
  </div>
  <input hidden (change)="uploadFileCallback($event)" #sourceFileInput type="file" id="sourceFileInput" />
</div>

<form class="form-field-full source-form" [formGroup]="sourceForm">
  <div class="m-t-24 flex-col source-data">
    <div class="d-flex flex-col m-r-48">
      <div class="d-flex justify-content-between w-full">
        <div class="item">Filename</div>
        <div class="item field">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full">
            <input formControlName="name" matInput type="text" required />
          </mat-form-field>
        </div>
      </div>
      <div class="d-flex justify-content-between w-full m-b-24">
        <div class="item">Status</div>
        <div class="item field">
          <!-- <mat-chip-listbox aria-label="Status" formControlName="status">
            <mat-chip-option (click)="onStatus()" [value]="allowedStatuses.ACTIVE" color="{{ selectedItem.status === allowedStatuses.ACTIVE && 'accent' }}" selected="{{ selectedItem.status === allowedStatuses.ACTIVE }}">{{ allowedStatuses.ACTIVE | titlecase }}</mat-chip-option>
            <mat-chip-option (click)="onStatus()"[value]="allowedStatuses.INACTIVE" color="{{ selectedItem.status === allowedStatuses.INACTIVE && 'accent' }}" selected="{{ selectedItem.status === allowedStatuses.INACTIVE }}">{{ allowedStatuses.INACTIVE | titlecase }}</mat-chip-option>
          </mat-chip-listbox> -->

          <mat-radio-group aria-label="Status" class="radio-group">
            <mat-radio-button (click)="onStatus()" [value]="allowedStatuses.ACTIVE">{{ allowedStatuses.ACTIVE | titlecase }}</mat-radio-button>
            <mat-radio-button (click)="onStatus()" [value]="allowedStatuses.INACTIVE">{{ allowedStatuses.INACTIVE | titlecase }}</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
      <div class="d-flex justify-content-between w-full">
        <div class="item">Publication Date</div>
        <div class="item field">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full">
            <input formControlName="publicationDate" matInput [matDatepicker]="picker" placeholder="Choose a date" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="d-flex justify-content-between w-full">
        <div class="item">Priority</div>
        <div class="item field">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full">
            <mat-select formControlName="priority" placeholder="Select a priority level">
              @for (val of [1, 2, 3, 4, 5]; track val) { <mat-option [value]="val">{{ getPriorityLabel(val) }}</mat-option> }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="d-flex justify-content-between w-full">
        <div class="item">Country</div>
        <div class="item field">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full">
            <mat-select placeholder="Select country" formControlName="countries" multiple>
              @for (value of getCountriesAndRegions(); track value; let i = $index) {
                <mat-option [value]="value._id">{{ value.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="d-flex m-b-24">
        <div class="item">Content</div>
        <div class="item field">
          <button mat-raised-button color="accent" (click)="openContentModal()">{{ !selectedItem.content ? 'Add content' : 'Show content' }}</button>
          <button mat-stroked-button class="m-l-16" color="primary" (click)="openConfirmationModal()">Regenerate embeddings</button>
        </div>
      </div>
      <div class="d-flex m-b-24">
        <div class="item">References</div>
        <div class="item field item--large-h item--large-w">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field source-form-field--textarea w-full">
            <textarea matInput class="" formControlName="references"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- New summary field display -->
      @if (selectedItem.summary) {
        <div class="d-flex m-b-24">
          <div class="item">Summary</div>
          <div class="item field item--large-h item--large-w">
            <div class="content-display">{{ selectedItem.summary }}</div>
          </div>
        </div>
      }

      <!-- New keywords field display -->
      @if (selectedItem.keywords && selectedItem.keywords.length > 0) {
        <div class="d-flex m-b-24">
          <div class="item">Keywords</div>
          <div class="item field">
            <div class="tags-container">
              <mat-chip-listbox aria-label="Keywords" [selectable]="false">
                @for (keyword of selectedItem.keywords; track keyword) { <mat-chip-option [selectable]="false">{{ keyword }}</mat-chip-option> }
              </mat-chip-listbox>
            </div>
          </div>
        </div>
      }

      <!-- New citations field display -->
      @if (selectedItem.citations && selectedItem.citations.length > 0) {
        <div class="d-flex m-b-24">
          <div class="item">Citations</div>
          <div class="item field">
            <div class="tags-container">
              <mat-chip-listbox aria-label="Citations" [selectable]="false">
                @for (citation of selectedItem.citations; track citation) { <mat-chip-option [selectable]="false">{{ citation }}</mat-chip-option> }
              </mat-chip-listbox>
            </div>
          </div>
        </div>
      }

      <!-- New citations count field display -->
      @if (selectedItem.citations_count !== undefined) {
        <div class="d-flex m-b-24">
          <div class="item">Citations Count</div>
          <div class="item field">
            <div class="content-display">{{ selectedItem.citations_count }}</div>
          </div>
        </div>
      }

      <div class="d-flex">
        <div class="item item--with-button">
          <span>Metadata</span>
          <button mat-icon-button color="accent" (click)="addNewMetadata()"><mat-icon>add</mat-icon></button>
        </div>
        @if (metadata.controls.length > 0) {
          <div class="item field metadata-field d-flex flex-col">
            <div formArrayName="metadata" class="metadata-list">
              @for (item of metadata.controls; track item; let i = $index) {
                <div [formGroupName]="i" class="d-flex metadata-row">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full m-r-8"><input matInput formControlName="slug" placeholder="Slug" /></mat-form-field>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full m-r-8"><input matInput formControlName="value" placeholder="Value" /></mat-form-field>
                  <button mat-icon-button color="accent" (click)="removeMetadata(i)"><mat-icon>delete</mat-icon></button>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="d-flex m-b-24 m-t-24">
        <div class="item">File</div>
        <div class="item field">
          <span class="file-name">{{ selectedItem.fileUrl || 'No file uploaded' }}</span>
        </div>
      </div>
      <div class="d-flex">
        <div class="item">File link</div>
        <div class="item field d-flex align-items-center file-link">
          @if (selectedItem.fileLink && !isFileLinkEditing) { <a href="{{ selectedItem.fileLink }}" target="_blank" >{{ selectedItem.fileLink }}</a> }
          @if (!selectedItem.fileLink || isFileLinkEditing) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="gingr-input-wrapper source-form-field w-full"><input formControlName="fileLink" matInput type="text" /></mat-form-field>
          }
          <button mat-icon-button aria-label="Edit file link" (click)="toggleFileLinkEditing()"><mat-icon>edit</mat-icon></button>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="files-footer">
  <button mat-stroked-button (click)="back()">Cancel</button>
  <button mat-raised-button color="primary" (click)="saveSource()">Save</button>
</div>
